export const reportsOptions = {
    extractCompanySubAdminReport: "extractCompanySubAdminReport"
};

export const reportsOptionsToText = {
    [reportsOptions.extractCompanySubAdminReport]: "דוח מימוש תקציב של תתי אדמין"
};
